import { MapPin, PhoneCall } from "lucide-react";
import { PageHero, Reveal } from "@/components/motion";
import { ContactForm } from "@/components/forms";

export default function ContactPage() {
  return (
    <>
      <PageHero
        testid="contact-hero"
        eyebrow="Contact us"
        lines={[<>Talk to</>, <span className="text-ice">the staff.</span>]}
        sub="Questions about the program, eligibility, camps or the process? Submit your info and our staff will call you back or email you back — your choice."
      />

      <section className="border-t border-white/5 py-24 sm:py-28">
        <div className="mx-auto grid max-w-7xl gap-14 px-5 sm:px-8 lg:grid-cols-[1.15fr_0.85fr]">
          <Reveal>
            <div className="glass rounded-2xl p-6 sm:p-8" data-testid="contact-form-card">
              <ContactForm />
            </div>
          </Reveal>

          <div className="space-y-6">
            <Reveal delay={0.1}>
              <div className="rounded-2xl border border-white/10 bg-navy-800 p-8">
                <PhoneCall className="h-7 w-7 text-ice" />
                <h3 className="mt-5 font-display text-2xl font-extrabold uppercase tracking-wide text-white">
                  A real person responds
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-300">
                  Our staff reads every submission personally. Ask for a callback and we call — prefer email and we
                  write. Expect a response from a coach or staff member, never an autoresponder.
                </p>
              </div>
            </Reveal>

            <Reveal delay={0.18}>
              <div
                data-testid="location-card"
                className="rounded-2xl border border-white/10 bg-navy-800 p-8 transition-colors hover:border-ice/50"
              >
                <MapPin className="h-7 w-7 text-crimson-bright" />
                <h3 className="mt-5 font-display text-2xl font-extrabold uppercase tracking-wide text-white">
                  The Academy
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-300">
                  4280 US-29
                  <br />
                  Tuskegee, Alabama
                </p>
                <p className="mt-4 font-mono text-[10px] uppercase leading-relaxed tracking-[0.16em] text-slate-500">
                  Visits by appointment — submit the form and we'll set a time.
                </p>
              </div>
            </Reveal>

            <Reveal delay={0.26}>
              <div className="clip-notch border border-ice/30 bg-ice/5 p-6">
                <p className="font-mono text-[11px] uppercase leading-relaxed tracking-[0.16em] text-slate-300">
                  No phone trees. No portals. Forms only — every submission goes straight to our staff.
                </p>
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </>
  );
}
